import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import {ConfirmationDialogComponent} from './dialog/dialog.component';
import {DialogService} from './dialog.service';
import {SelectDialogComponent} from './select-dialog/select-dialog.component';
import {FuseSharedModule} from '../../@fuse/shared.module';
import {MatSelectModule} from '@angular/material/select';

@NgModule({
    declarations: [
        ConfirmationDialogComponent,
        SelectDialogComponent
    ],
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        CommonModule,
        FuseSharedModule,
        MatSelectModule
    ],
    providers   : [
        DialogService
    ]
})
export class DialogModule
{
    /**
     * Constructor
     */
    constructor(private _dialogService: DialogService)
    {
    }
}
